import { useState, useRef, useEffect } from 'react';
import { CircularProgress, Slide } from '@mui/material';
import TWEEN from '@tweenjs/tween.js';
import { usePreloadTheme } from './ThemeHooks';
import { themesMap } from './ThemeMapping';
import './Theme.scss';
import { useDisableRightClick } from '../TerminologiesHooks';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';

const defaultProps = {
  onClick: () => {},
  lessonsCompleted: null,
  lessonsLength: null,
  themeTransition: {
    in: true,
    direction: 'left',
  },
  onReady: () => {},
};

const Theme = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { themeData, onClick, lessonsCompleted, lessonsLength, themeTransition, onReady } = mergedProps;
  const [ready, setReady] = useState(false);
  const themeList = useRef([themeData]);
  const pixiLoader = usePreloadTheme(themeList.current);
  const ThemeComponent = themesMap[themeData.id];

  const intervalRef = useRef(null);

  useDisableRightClick(ready);

  useEffect(() => (() => {
    clearInterval(intervalRef.current);
  }), []);

  if (pixiLoader && intervalRef.current == null) {
    pixiLoader.onComplete.add(() => {
      intervalRef.current = setInterval(() => {
        const resources = Object.keys(pixiLoader.resources).filter((key) => key.startsWith(themeData.id));
        const notCompleted = resources.length > 0 && resources.findIndex((r) => (pixiLoader.resources[r].isLoading));
        if (notCompleted < 0) {
          clearInterval(intervalRef.current);
          setReady(true);
        }
      }, 100);
    });
  }

  useEffect(() => {
    if (ready) {
      onReady();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready]);

  // Setup the animation loop.
  function animate(time) {
    requestAnimationFrame(animate);
    TWEEN.update(time);
  }
  requestAnimationFrame(animate);

  return (
    <div className='theme-player'>
      {ready ? (
        <Slide {...themeTransition} timeout={700}>
          <div className='theme-container' data-test='theme-component'>
            <ThemeComponent
              pixiLoader={pixiLoader}
              themeData={themeData}
              onClick={onClick}
              lessonsCompleted={lessonsCompleted}
              lessonsLength={lessonsLength}
            />
          </div>
        </Slide>
      ) : (
        <div className='loading'>
          <CircularProgress size={40} />
          <div className='loading-message'>
            Theme is loading.
          </div>
        </div>
      )}
    </div>
  );
};

export default Theme;
